﻿(function(global) {

	"use strict";

	// emu for tdclient.js
	if(global.Type === undefined) global.Type = {};

	function extend(o, p) {
		for(var x in p) {
			if(o[x] === undefined)
				o[x] = p[x];
		}
	}

	var _formatRE = /(\{[^}{]+\})/g;

	// String extensions
	extend(String, {

		compare: function String$compare(s1, s2, ignoreCase) {
			s1 = s1 || "";
			s2 = s2 || "";
			if(ignoreCase) {
				s1 = s1.toUpperCase();
				s2 = s2.toUpperCase();
			}
			return s1 == s2 ? 0 : s1 < s2 ? -1 : 1;
		},

		concat: function String$concat(/*arg1, arg2, argN*/) {
			return arguments.length == 2 ? arguments[0] + arguments[1] : Array.prototype.join.call(arguments, "");
		},

		fromChar: function String$fromChar(ch, count) {
			return count ? new Array(count + 1).join(ch) : ch;
		},

		format: function String$format(format/*, value1, value2, valueN*/) {
			var a = arguments;
			return format.replace(_formatRE, function(str, m) {
				var v = a[parseInt(m.substring(1)) + 1];
				return v != null ? v.toString() : "";
			});
		}
	});

	// String prototype extensions
	var _htmlDecMap = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"' };
	var _htmlDecRE = /(&amp;|&lt;|&gt;|&quot;)/gi;
	var _htmlEncMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };
	var _htmlEncRE = /([&<>"])/g;

	extend(String.prototype, {

		contains: String.prototype.includes,

		toArray: function String$toArray() {
			return this.split('');
		},

		htmlDecode: function String$htmlDecode() {
			return this.replace(_htmlDecRE, function(_str, m) { return _htmlDecMap[m]; });
		},

		htmlEncode: function String$htmlEncode() {
			return this.replace(_htmlEncRE, function (_str, m) { return _htmlEncMap[m]; });
		},

		padLeft: String.prototype.padStart,

		padRight: String.prototype.padEnd,

		insert: function String$insert(index, value) {
			if(!value) return this;
			if(!index) return value + this;
			return this.substring(0, index) + value + this.substring(index);
		},

		remove: function String$remove(index, count) {
			if(!count || ((index + count) > this.length))
				return this.substring(0, index);
			return this.substring(0, index) + this.substring(index + count);
		}
	});

	var ua = navigator.userAgent;
	global.isIOS = /iP(ad|od|hone)/.test(ua) && /AppleWebKit\//.test(ua) && !/CriOS\//.test(ua);
})(window);